export default {
    key: 'eigerrun',
    type: 'Activity',
    isUsingProductConfigPresets: false,
    isUsingProductPresets: true,
    hideCrossSells: false,
    disablePassengers: false,
    isLoadingPassengerOffers: true,
    isRental: false,
    activityId: '43a8e505-a5af-4302-987a-5b2f514fd9e2',
    categoryId: undefined,
    defaultDuration: 1440,
    isMultiDay: false,
    isUsingReductionCards: true,
    isUsingKeyCards: false,
    hidePassengerMeasurements: false,
    isUsingPromos: false,
    isPromotionRequired: false,
    showDuration: false,
    upsells: [],
    salesTimeLimit: undefined,
    isUpsellDatesRestricted: false,
    maxNumberOfPeople: 10,
    maxNumberOfPeopleGroupTariff: undefined,
    isUsingSeasonDates: false,
    defaultPassengerAge: 30,
    hiddenProductReductionCard: undefined,
    listingId: '43a8e505-a5af-4302-987a-5b2f514fd9e2',
    contentfulId: 'eigerrun',
    steps: [],
} satisfies ProductConfigActivity;
